<div class="p-5">
   <div class="contract">
      <div [innerHTML]="contract"></div>
   </div>

   <div class="row g-0 mt-4">

      <div class="signature-container d-flex flex-column justify-content-center p-2">
         <p class="mb-0 cl-primary fw-sbold fs-13">Monific</p>
         <img src="assets/app-icons/384.png" class="my-4 logo" alt="">
         <p class="mb-0 cl-primary fs-13">Firmado por medio de firma electrónica</p>
         <hr>
         <p class="mb-0 cl-primary fs-13">MONIFIC, S.A. DE C.V., INSTITUCIÓN DE FINANCIAMIENTO COLECTIVO</p>
      </div>


      <div class="signature-container d-flex flex-column justify-content-center p-2 mt-4 mt-sm-0">

         <p class="mb-0 cl-primary fw-sbold fs-13">INVERSIONISTA</p>

         <p class="mb-0 cl-primary fs-13">Firmado por medio de firma electrónica</p>

         <hr>
         <p class="mb-0 cl-primary fs-13">{{ userName }}</p>
      </div>

      <div class="w-100 text-center mt-5 mb-4">
         <button class="btn cl-white bg-primary-card m-auto d-block btn-padding mt-5 fs-18 btn-h" (click)="acceptAutoinvestContract()">Firmar</button>

      </div>
   </div>

</div>
